import { render } from "./EscalationDetailModal.vue?vue&type=template&id=78fd0dbe&scoped=true"
import script from "./EscalationDetailModal.vue?vue&type=script&lang=js"
export * from "./EscalationDetailModal.vue?vue&type=script&lang=js"

import "./EscalationDetailModal.vue?vue&type=style&index=0&id=78fd0dbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fd0dbe"]])

export default __exports__